import { Navigate, useLocation } from "react-router";
import { DEFAULT_TAB } from "../containers/MrpView/tabs";

/** `/bom-explorer` → the MRP page's BOM Explorer tab, the query string
 *  (`?item=`) intact: the explorer's old address, so every link and bookmark
 *  minted against it keeps opening the same recipe. */
export const BomExplorerRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: DEFAULT_TAB.path, search }} replace />;
};
